<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
const store = useStore();
const isLoading = computed(() => {
  return { 'is-loading': store.state.loader.isLoading };
});
</script>

<template>
  <div :class="isLoading" class="c-loading-overlay">
    <div class="visually-hidden" aria-live="polite">
      <p>Loading content&hellip;</p>
    </div>
    <div class="c-loading-overlay__spinner">
      <div class="c-loading-overlay__circle" />
      <div class="c-loading-overlay__circle" />
      <div class="c-loading-overlay__circle" />
      <div class="c-loading-overlay__circle" />
      <div class="c-loading-overlay__circle" />
      <div class="c-loading-overlay__circle" />
      <div class="c-loading-overlay__circle" />
      <div class="c-loading-overlay__circle" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@/ui/styles/functions/functions';
@import '@/ui/styles/settings/colors';

@keyframes lds-roller {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.c-loading-overlay {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2003; // sit above reciteme
  visibility: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  background: rgba($white, 0.75);
  opacity: 0;
  transition: opacity 0.2s cubic-bezier(0.5, 0, 0.5, 1);
  pointer-events: none;

  &.is-loading {
    visibility: visible;
    opacity: 1;
    pointer-events: unset;
  }
}

.c-loading-overlay__spinner {
  position: relative;
  z-index: 1;
  display: inline-block;
  height: rem(80px);
  width: rem(80px);
  @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
    position: absolute; // IE11 fallback
    top: 50%;
    left: 50%;
    transform: translate(-50%, 50%);
  }
}

.c-loading-overlay__circle {
  transform-origin: rem(40px) rem(40px);
  animation: lds-roller 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;

  &:after {
    content: '';
    position: absolute;
    display: block;
    margin: rem(-4px) 0 0 rem(-4px);
    height: rem(7px);
    width: rem(7px);
    background: $color-brand-one;
    border-radius: 50%;
  }

  &:nth-child(1) {
    animation-delay: -0.036s;
  }

  &:nth-child(1):after {
    top: rem(63px);
    left: rem(63px);
  }

  &:nth-child(2) {
    animation-delay: -0.072s;
  }

  &:nth-child(2):after {
    top: rem(68px);
    left: rem(56px);
  }

  &:nth-child(3) {
    animation-delay: -0.108s;
  }

  &:nth-child(3):after {
    top: rem(71px);
    left: rem(48px);
  }

  &:nth-child(4) {
    animation-delay: -0.144s;
  }

  &:nth-child(4):after {
    top: rem(72px);
    left: rem(40px);
  }

  &:nth-child(5) {
    animation-delay: -0.18s;
  }

  &:nth-child(5):after {
    top: rem(71px);
    left: rem(32px);
  }

  &:nth-child(6) {
    animation-delay: -0.216s;
  }

  &:nth-child(6):after {
    top: rem(68px);
    left: rem(24px);
  }

  &:nth-child(7) {
    animation-delay: -0.252s;
  }

  &:nth-child(7):after {
    top: rem(63px);
    left: rem(17px);
  }

  &:nth-child(8) {
    animation-delay: -0.288s;
  }

  &:nth-child(8):after {
    top: rem(56px);
    left: rem(12px);
  }
}
</style>
